import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Popup from "../../../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import NavigateLink from "../../../../../shared/components/features/navigateLink/navigateLink";
import pathRouts from "../../../../../shared/enums/pathRoute";
import MobileBanner from "../../../../../shared/components/ui/mobileBanner/MobileBanner";
import moodleIcon from "../../../../../assests/createStudyGroup/moodle/moodleIcon.png"
import CreateStudyGroup from "../../../../../assests/createStudyGroup/moodle/CreateStudyGroup .png"
import MoodleStep from "./moodleStep/MoodleStep";
import ContentsPopup from "../../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import logo from '../../../../../assests/createStudyGroup/moodle/logo.png'
import classes from "./MoodleWizardPopup.module.css"


const MoodleWizardPopup = ({ onClose, moodle }) => {

    const navigate = useNavigate()
    const { texts } = useSelector(state => state.translate)

    return (
        <Popup close={onClose} title={texts.openStudyGroup} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose} >
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.openStudyGroup}</p>
            </HeaderPopup>
            <ContentsPopup className={classes.Content}>
                <div className={classes.StepContainer}>
                    <MoodleStep number={1} title={texts.moveToMoodle} icon={moodleIcon} />
                    <MoodleStep number={2} title={texts.openNewStudyGroupInMoodle} icon={moodleIcon} />
                    <MoodleStep number={3} icon={logo}>
                        <span className={classes.MoodleStepText}>
                            {texts.MoodleStudyGroupsJoinToNotUnaffiliatedPage}
                            <span onClick={() => navigate(`/${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`)} className={classes.link}>
                                {texts.MoodleNotAffiliatedPageLinkText}
                            </span>
                        </span>
                    </MoodleStep>
                    <MoodleStep number={4} title={texts.AssociateTheNewSpaceIntoTheStudyGroup} icon={CreateStudyGroup} />
                </div>
                <MobileBanner text={texts.moodleWizardMobileBanner} className={classes.MobileBanner} />
            </ContentsPopup>
            <div className={classes.Actions}>
                <NavigateLink link={moodle?.link}>
                    <div className={classes.next} onClick={onClose}>
                        <p className={classes.text}> {texts.openMoodlLinkInNewTab} </p>
                    </div>
                </NavigateLink>
            </div>
        </Popup>

    );
};

export default MoodleWizardPopup;
